import { Toast } from 'react-vant';

export const doDownLoadFile = function (res, filename = null) {
  return new Promise<void>(async (resolve, reject) => {
    try {
      const dispositionName: string = res.headers.get('Content-disposition');
      const [, , blobFileName] = decodeURIComponent(dispositionName.match(/=(.*)$/)[1]).split("'");
      const a = await res.blob();
      const blob = new Blob([a], { type: `application/octet-stream` });
      const url = window.URL.createObjectURL(blob);
      const dom = document.createElement('a');
      dom.href = url;
      dom.download = filename || blobFileName; // 用dom的download下载，可以设置默认文件名
      dom.style.display = 'none';
      document.body.appendChild(dom);
      dom.click();
      dom.parentNode.removeChild(dom); // 释放内存
      window.URL.revokeObjectURL(url); // 释放内存
      Toast.success('下载成功');
      resolve();
    } catch (err) {
      reject(err);
    }
  });
};
// 下载文件接口API

const downLoadFile = async (url, options?: { method: string; headers: any; body: any }) => {
  const wrapBody = () => {
    let str = '';
    if (options?.body) {
      Object.entries(options?.body).map(([key, value]) => (str += `&${key}=${value}`));
    }
    return str;
  };
  const optionObj = {
    method: options?.method || 'POST',
    headers: { 'Content-Type': options?.headers?.contentType || 'application/json;charset=utf-8' },
    body: wrapBody(),
  };
  return new Promise<void>((resolve, reject) => {
    window.fetch(url, optionObj).then((res) => {
      if (!res.ok) {
        Toast.fail('服务器内部错误');
        reject();
      } else {
        doDownLoadFile(res).then(resolve, reject);
      }
    }, reject);
  });
};

export default downLoadFile;
